import { useParams } from 'react-router-dom';

import { Loader } from 'components/Loader';
import { useGetDetailedTotemsOfOrganizationQuery } from 'data/__generated__';

import { EmbeddedSitesTable } from 'pages/Sites/components/EmbeddedSitesTable';
import type { EmbeddedSiteRow } from 'pages/Sites/constants/embeddedSitesColumns';

type ParamTypes = {
    organizationId: string;
};

export const SitesDetails = () => {
    const { organizationId = '' } = useParams<ParamTypes>();

    // Reuses the same query as the Totems section — Apollo dedupes it from cache, so no extra network round-trip.
    // An organization has no direct "sites" relation: its sites are the union of its totems' sites.
    const { loading, error, data } = useGetDetailedTotemsOfOrganizationQuery({
        variables: { organizationId },
    });

    if (loading) {
        return (
            <div className="flex min-h-[200px] w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (error || !data) {
        throw new Error('Une erreur est survenue lors de la récupération des sites');
    }

    const sites: EmbeddedSiteRow[] = data.totemsOfOrganization.flatMap((totem) =>
        totem.sites.map((site) => ({ ...site, totemFullname: totem.fullname })),
    );

    return <EmbeddedSitesTable sites={sites} showTotemColumn />;
};
